import Icon from "@visa/vds/icon";
import React from "react";
import CookieConsent from "react-cookie-consent";
function CookieBanner() {
  return (
    <>
      <CookieConsent
        location="top"
        buttonText={<span className="vds-btn-label">Accept</span>}
        cookieName="vss-cookie-consent"
        buttonStyle={{ background: "white", color: "black" }}
        expires={30}
        overlay
        containerClasses="vss-cookie-consent-container"
        contentClasses="vss-cookie-consent-content"
        buttonWrapperClasses="vss-cookie-consent-button-wrapper"
        buttonClasses="vds-btn-text--tertiary"
      >
        <p>
          We use cookies to give you the best online experience, and measure
          your visits to our sites (including with our partners). For details,
          see the{" "}
          <a rel="opener" target="_blank" href="https://visa.com/cookie-notice">
            Visa Cookie Notice
            <Icon name="maximize" resolution="tiny" />
          </a>
        </p>
      </CookieConsent>
    </>
  );
}

export default CookieBanner;
